export default __webpack_public_path__ + "static/media/facebook.305a3e06.svg";